"use strict";

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _bluebird = require("bluebird");

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _MatrixClientPeg = require("./MatrixClientPeg");

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _dispatcher = require("./dispatcher");

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _Timer = require("./utils/Timer");

var _Timer2 = _interopRequireDefault(_Timer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Time in ms after that a user is considered as unavailable/away
var UNAVAILABLE_TIME_MS = 3 * 60 * 1000; // 3 mins
/*
Copyright 2015, 2016 OpenMarket Ltd
Copyright 2018 New Vector Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var PRESENCE_STATES = ["online", "offline", "unavailable"];

var Presence = function () {
    function Presence() {
        (0, _classCallCheck3.default)(this, Presence);

        this._activitySignal = null;
        this._unavailableTimer = null;
        this._onAction = this._onAction.bind(this);
        this._dispatcherRef = null;
    }
    /**
     * Start listening the user activity to evaluate his presence state.
     * Any state change will be sent to the homeserver.
     */


    (0, _createClass3.default)(Presence, [{
        key: "start",
        value: function () {
            var _ref = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this._unavailableTimer = new _Timer2.default(UNAVAILABLE_TIME_MS);
                                // the user_activity_start action starts the timer
                                this._dispatcherRef = _dispatcher2.default.register(this._onAction);

                            case 2:
                                if (!this._unavailableTimer) {
                                    _context.next = 13;
                                    break;
                                }

                                _context.prev = 3;
                                _context.next = 6;
                                return (0, _bluebird.resolve)(this._unavailableTimer.finished());

                            case 6:
                                this.setState("unavailable");
                                _context.next = 11;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context["catch"](3);

                            case 11:
                                _context.next = 2;
                                break;

                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[3, 9]]);
            }));

            function start() {
                return _ref.apply(this, arguments);
            }

            return start;
        }()

        /**
         * Stop tracking user activity
         */

    }, {
        key: "stop",
        value: function stop() {
            if (this._dispatcherRef) {
                _dispatcher2.default.unregister(this._dispatcherRef);
                this._dispatcherRef = null;
            }
            if (this._unavailableTimer) {
                this._unavailableTimer.abort();
                this._unavailableTimer = null;
            }
        }

        /**
         * Get the current presence state.
         * @returns {string} the presence state (see PRESENCE enum)
         */

    }, {
        key: "getState",
        value: function getState() {
            return this.state;
        }
    }, {
        key: "_onAction",
        value: function _onAction(payload) {
            if (payload.action === 'user_activity') {
                this.setState("online");
                this._unavailableTimer.restart();
            }
        }

        /**
         * Set the presence state.
         * If the state has changed, the homeserver will be notified.
         * @param {string} newState the new presence state (see PRESENCE enum)
         */

    }, {
        key: "setState",
        value: function () {
            var _ref2 = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(newState) {
                var oldState;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(newState === this.state)) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt("return");

                            case 2:
                                if (!(PRESENCE_STATES.indexOf(newState) === -1)) {
                                    _context2.next = 4;
                                    break;
                                }

                                throw new Error("Bad presence state: " + newState);

                            case 4:
                                oldState = this.state;

                                this.state = newState;

                                if (!_MatrixClientPeg2.default.get().isGuest()) {
                                    _context2.next = 8;
                                    break;
                                }

                                return _context2.abrupt("return");

                            case 8:
                                _context2.prev = 8;
                                _context2.next = 11;
                                return (0, _bluebird.resolve)(_MatrixClientPeg2.default.get().setPresence(this.state));

                            case 11:
                                console.log("Presence: %s", newState);
                                _context2.next = 18;
                                break;

                            case 14:
                                _context2.prev = 14;
                                _context2.t0 = _context2["catch"](8);

                                console.error("Failed to set presence: %s", _context2.t0);
                                this.state = oldState;

                            case 18:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[8, 14]]);
            }));

            function setState(_x) {
                return _ref2.apply(this, arguments);
            }

            return setState;
        }()
    }]);
    return Presence;
}();

module.exports = new Presence();
//# sourceMappingURL=Presence.js.map